<template>
  <div class="mobile-menu">
    <button class="menu-button" @click="goTo('ComoFunciona')">
      <i class="ri-questionnaire-fill"></i>
      <span>Como <br />funciona?</span>
    </button>
    <button @click="goTo('')" class="menu-button">
      <i class="ri-flashlight-fill"></i>
      <span>Todas <br />Boxes</span>
    </button>
    <div class="text-center">
      <button
        class="menu-button btn-center"
        :disabled="isDisabledButton"
        @click="clickOpenCaixa()"
      >
        <img src="@/assets/openbox-white.svg" alt="Abrir Caixa" />
      </button>
      <!-- <button class="menu-button btn-center">
        <img src="@/assets/openbox-white.svg" alt="Abrir Caixa" />
      </button>-->
      <span v-html="texto"></span>
    </div>
    <button class="menu-button" @click="goTo('meusItens')">
      <i class="ri-list-unordered"></i>
      <span
        >Meus <br />
        Produtos</span
      >
    </button>
    <button class="menu-button" @click="goTo('Dashboard')">
      <i class="ri-user-fill"></i>
      <span
        >Minha <br />
        Conta</span
      >
    </button>
    <modal
      :show.sync="modalCaixas"
      :show-close="true"
      body-classes="p-0"
      modal-classes="modal-dialog-centered text-white modal-caixas"
      close-classes="text-white"
    >
      <div>
        <boxesHome class="my-3" :fromHome="true"></boxesHome>
      </div>
    </modal>
    <modal
      :show.sync="modalLogin"
      :show-close="true"
      body-classes="p-3 text-white pb-5"
      modal-classes="modal-dialog-centered "
      close-classes="text-white"
    >
      <slot name="header"><h3>Acesse sua Conta</h3> </slot>
      <div>
        <formLogin :insideBox="true" @login="logged" :key="keyOpen"></formLogin>
      </div>
    </modal>

    <modal
      :show.sync="modalSaldo"
      :show-close="true"
      body-classes="p-3  text-white pb-5 "
      modal-classes="modal-dialog-centered "
      close-classes="text-white"
      @close="logged"
    >
      <div>
        <slot name="header"><h3>Adicionar Créditos</h3> </slot>
        <formSaldo
          :insideBox="true"
          @erroLogin="disparaErroLogin"
          :valorFaltante="valorFaltante"
          @CloseModal="logged"
          :key="keyOpen"
        ></formSaldo>
      </div>
    </modal>
  </div>
</template>
<script>
import { Card, Tabs, TabPane, Button, NavLink, Modal } from '@/components';
import boxesHome from './../pages/v2/componentes/boxesHome.vue';
import formLogin from './../pages/components_site/formLogin.vue';
import formSaldo from './../pages/components_site/formPagamentos.vue';
export default {
  props: {
    isDetalheCaixa: Boolean,
    textBotao: String,
    isDisabledButton: Boolean,
    saldoInsuficiente: Boolean,
    valorFaltante: String,
    needsLogin: Boolean,
  },
  watch: {
    needsLogin(newValue) {
      if (newValue == true) {
        this.modalLogin = true;
      }
    },
    saldoInsuficiente(newValue) {
      if (newValue == true) {
        this.modalSaldo = true;
      }
    },
    textBotao(newValue) {
      if (this.isDisabledButton) {
        this.texto = 'Aguarde';
        return;
      } else {
        this.texto = 'Abrir <br>Caixa';
      }
    },
  },
  components: {
    Card,
    Tabs,
    TabPane,
    [Button.name]: Button,
    NavLink,
    Modal,
    boxesHome,
    formLogin,
    formSaldo,
  },
  data() {
    return {
      modalCaixas: false,
      isDisabled: false,
      aberturaRapida: false,
      modalLogin: false,
      modalSaldo: false,
      keyOpen: 0,
      texto: 'Abrir <br>Caixa',
    };
  },

  methods: {
    disparaErroLogin() {
      this.modalLogin = true;
      this.modalSaldo = false;
    },
    abrirCaixa() {
      this.keyOpen = this.keyOpen + 1;
      console.log('teste');

      if (this.needsLogin == true) {
        console.log('abre Modal de Login');
        this.modalLogin = true;
        return;
      }

      if (this.saldoInsuficiente == true) {
        console.log('abre Modal de Saldo');
        this.modalSaldo = true;
        return;
      }

      this.$emit('EventoToRoleta', {
        evento: 'Sortear',
      });
    },
    clickOpenCaixa() {
      this.isDisabled = true;
      if (this.isDetalheCaixa == true) {
        this.abrirCaixa();
      } else this.modalCaixas = true;
    },
    goTo(path) {
      this.$router.push('/' + path);
    },
    logged() {
      this.modalLogin = false;
      this.modalSaldo = false;
      this.$emit('AtualizaGeral');
    },
  },
};
</script>
<style lang="scss">
.modal-caixas {
  z-index: 1050 !important;
}
</style>
